import axios from 'axios'; 
import { clearStorage, getFromStorage , setToStorage} from './storage';

const onRequest = async (config) => {
    const token = getFromStorage('accessToken')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
        config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
};

const onRequestError = (error) => {
    return Promise.reject(error);
};
const refreshAccessToken = async () => {
    const refreshToken = getFromStorage('refreshToken');
    if (!refreshToken) {
        return Promise.reject('No refresh token available');
    }

    try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}users/refreshAccessToken`, {
            refreshToken,
        });

        const newAccessToken = response.data.data.accessToken;

        
        setToStorage('accessToken', newAccessToken);
        return newAccessToken;
    } catch (error) {
        return Promise.reject('Failed to refresh access token');
    }
};

const onResponse = (response) => {
    if (response.data.status === false) {
        return Promise.reject(response.data);
    }
    return response;
};

const onResponseError = async (error) => {
    if (error.response?.status === 401) {
        try {
            const newAccessToken = await refreshAccessToken();

            error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;

            return axios(error.config);
        } catch (refreshError) {
            clearStorage();  
            window.location.href = '/';
            return Promise.reject(refreshError);
        }
    }
    return Promise.reject(error.response?.data || error.message);
};

function setupInterceptorsTo(axiosInstance) {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
}

export const axiosInstance= setupInterceptorsTo(
    axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        timeout: 50000
    })
);

export { setupInterceptorsTo };
